module.exports = __webpack_public_path__ + "img/bg103_16.24da6a69.png";